import { createSlice } from '@reduxjs/toolkit';
import { setAuthHeader } from '../../utils/axiosHeaders';
import { User } from 'oidc-client';
import { AppDispatch } from '../../store';

export interface AuthState {
  user: User | null;
  isLoadingUser: boolean;
}

const initialState: AuthState = {
  user: null,
  isLoadingUser: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    storeUser: (state, action) => {
      return { ...state, isLoadingUser: false, user: action.payload };
    },
    loadingUser: (state) => {
      state.isLoadingUser = true;
    },
    userExpired: (state) => {
      state.user = null;
      state.isLoadingUser = false;
    },
    storeUserError: (state) => {
      state.user = null;
      state.isLoadingUser = false;
    },
    userSignedOut: (state) => {
      state.user = null;
      state.isLoadingUser = false;
    },
  },
});

export const storeUserAndSetAuthHeader = (user: User) => {
  return (dispatch: AppDispatch) => {
    setAuthHeader(user.access_token);
    dispatch(authSlice.actions.storeUser(user));
  };
};

export const authActions = { ...authSlice.actions, storeUserAndSetAuthHeader };
export default authSlice;
